import CKEditor from 'ckeditor4-vue';

export default {
  components: {
    // Use the <ckeditor> component in this view.
    ckeditor4: CKEditor.component,
  },
  props: [],
  data() {
    return {
      editorConfig: {
        height: '800px',
        contentsCss: location.protocol + '//' + location.hostname + '/css/editor-cow-project.css',
        filebrowserImageUploadUrl:
          location.protocol +
          '//' +
          location.hostname +
          '/api/file/upload2?CKEditor=fokjn&CKEditorFuncNum=1&langCode=ko',
        uploadUrl:
          location.protocol +
          '//' +
          location.hostname +
          '/api/file/upload2?CKEditor=fokjn&CKEditorFuncNum=1&langCode=ko',
        toolbarGroups: [
          { name: 'clipboard', groups: ['clipboard', 'undo'] },
          { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
          { name: 'links', groups: ['links'] },
          { name: 'insert', groups: ['insert'] },
          { name: 'forms', groups: ['forms'] },
          { name: 'tools', groups: ['tools'] },
          { name: 'document', groups: ['mode', 'document', 'doctools'] },
          { name: 'others', groups: ['others'] },
          '/',
          { name: 'styles', groups: ['styles'] },
          { name: 'colors', groups: ['colors'] },
          { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] },
          { name: 'about', groups: ['about'] },
          { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
        ],
        removeButtons:
          'Flash,Smiley,ShowBlocks,About,BidiLtr,BidiRtl,Language,Form,Checkbox,Radio,TextField,Textarea,Select,Button,HiddenField,ImageButton,Scayt,SelectAll,Find,Replace,Save,NewPage,Preview,Print,Templates',
        extraPlugins:
          'justify,font,colorbutton,colordialog,filebrowser,uploadwidget,removeformat,embedsemantic,div,uploadimage',
        stylesSet: [
          {
            name: '단락 아래 주석',
            element: 'p',
            styles: {
              color: 'rgb(127, 140, 141)',
              'font-size': '14px',
              'margin-top': '0.3rem',
            },
          },
          { name: 'Big', element: 'big' },
          { name: 'Quote', element: 'q' },
          {
            name: 'Styled Image (left)',
            element: 'img',
            attributes: { class: 'left' },
          },
          {
            name: 'Styled Image (right)',
            element: 'img',
            attributes: { class: 'right' },
          },
          {
            name: 'Compact Table',
            element: 'table',
            attributes: {
              cellpadding: '5',
              cellspacing: '0',
              border: '1',
              bordercolor: '#ccc',
            },
            styles: {
              'border-collapse': 'collapse',
            },
          },
          {
            name: 'Borderless Table',
            element: 'table',
            styles: { 'border-style': 'hidden', 'background-color': '#E6E6FA' },
          },
          { name: 'Square Bulleted List', element: 'ul', styles: { 'list-style-type': 'square' } },
          { name: 'Clean Image', type: 'widget', widget: 'image', attributes: { class: 'image-clean' } },
          { name: 'Grayscale Image', type: 'widget', widget: 'image', attributes: { class: 'image-grayscale' } },
          { name: 'Featured Snippet', type: 'widget', widget: 'codeSnippet', attributes: { class: 'code-featured' } },
          { name: 'Featured Formula', type: 'widget', widget: 'mathjax', attributes: { class: 'math-featured' } },
          { name: '240p', type: 'widget', widget: 'embedSemantic', attributes: { class: 'embed-240p' }, group: 'size' },
          { name: '360p', type: 'widget', widget: 'embedSemantic', attributes: { class: 'embed-360p' }, group: 'size' },
          { name: '480p', type: 'widget', widget: 'embedSemantic', attributes: { class: 'embed-480p' }, group: 'size' },
          { name: '720p', type: 'widget', widget: 'embedSemantic', attributes: { class: 'embed-720p' }, group: 'size' },
          {
            name: '1080p',
            type: 'widget',
            widget: 'embedSemantic',
            attributes: { class: 'embed-1080p' },
            group: 'size',
          },
          { name: '240p ', type: 'widget', widget: 'embed', attributes: { class: 'embed-240p' }, group: 'size' },
          { name: '360p ', type: 'widget', widget: 'embed', attributes: { class: 'embed-360p' }, group: 'size' },
          { name: '480p ', type: 'widget', widget: 'embed', attributes: { class: 'embed-480p' }, group: 'size' },
          { name: '720p ', type: 'widget', widget: 'embed', attributes: { class: 'embed-720p' }, group: 'size' },
          { name: '1080p ', type: 'widget', widget: 'embed', attributes: { class: 'embed-1080p' }, group: 'size' },
        ],
        disallowedContent: 'img{width,height}',
      },
    };
  },
  computed: {},
  methods: {},
};
